export default __webpack_public_path__ + "static/csv-7f4afbb0007af84bdf0774e5de7fff99.jpg";